import React, { useRef } from 'react';
import './landing-page.vendor.container.sass';
import {Header} from '../components/header/header';
import {Footer} from '../components/footer/footer';
import {JoinUs} from '../components/join-us/join-us';
import {HowItWorks} from '../components/how-it-works/how-it-works';
import {Form} from '../components/form/form';

export const LandingPageVendorContainer = () => {
    const scrollRef = useRef(null);

    return (
        <div className='vv-landing-page-vendor-container'>
            <Header scrollRef={scrollRef}/>
            <JoinUs scrollRef={scrollRef}/>
            <HowItWorks/>
            <Form scrollRef={scrollRef}/>
            <Footer/>
        </div>
    );
};